import createClient from "openapi-react-query"

import { createApiClient } from "@/api/utils"
import { env } from "@/env"
import type { paths as groupsFoldersPaths } from "@/types/api/groups/v1/folders/schema.gen"
import type { paths as groupsSmartFoldersPaths } from "@/types/api/groups/v1/smartfolders/schema.gen"
import type { paths as groupsViewsPaths } from "@/types/api/groups/v1/views/schema.gen"

const groupsClient = createApiClient<groupsViewsPaths>({
  baseUrl: env.VITE_API2_URL,
  querySerializer: { array: { style: "form", explode: false } }
})
const groupsFoldersClient = createApiClient<groupsFoldersPaths>({
  baseUrl: env.VITE_API2_URL,
  querySerializer: { array: { style: "form", explode: false } }
})
const groupsSmartFoldersClient = createApiClient<groupsSmartFoldersPaths>({
  baseUrl: env.VITE_API2_URL
})

// Vanilla API client
export const $groupsViewApiClient = groupsClient.vanillaClient
export const $groupsFoldersApiClient = groupsFoldersClient.vanillaClient
export const $groupsSmartFoldersApiClient = groupsSmartFoldersClient.vanillaClient

// React-Query client
export const $rqViewsApiClient = createClient(groupsClient.rqClient)
export const $rqFoldersApiClient = createClient(groupsFoldersClient.rqClient)
export const $rqSmartFoldersApiClient = createClient(groupsSmartFoldersClient.rqClient)
